import Vue from 'vue';
import App from './App.vue';
import router from './router';

import '../node_modules/@fortawesome/fontawesome-free/scss/fontawesome.scss';
import '../node_modules/@fortawesome/fontawesome-free/scss/solid.scss';
import '../node_modules/bulma/bulma.sass';

import { Auth0Plugin } from '@/auth0-plugin';

Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirectUri: process.env.VUE_APP_AUTH0_CALLBACK_URL,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  onRedirectCallback: (appState) => {
    history.replaceState({}, document.title, window.location.pathname);
    router.push(
      appState && appState.targetPath
        ? appState.targetPath
        : window.location.pathname,
    );
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
